import { GLENDALE_DISTRICT_ID } from "./glendaleDistrict";

/**
 * Map version configurations to their names
 */
export const configurationVersions = {
  swing: "Swing Education",
  [GLENDALE_DISTRICT_ID]: "Glendale District",
  "1": "District A (Test Only)",
  "2": "District B (Test Only)",
} as const;

/**
 * Type representing valid version configurations
 */
export type Version = keyof typeof configurationVersions;

/**
 * Given a `version`, return lazily the matching configuration
 */
export async function getConfiguration(version: Version) {
  switch (version) {
    case "swing":
      return (await import("./swing")).SwingConfiguration;
    case "1":
      return (await import("./testDistrictA")).TestDistrictAConfiguration;
    case "2":
      return (await import("./testDistrictB")).TestDistrictBConfiguration;
    case GLENDALE_DISTRICT_ID:
      return (await import("./glendaleDistrict")).GlendaleDistrictConfiguration;
    default:
      throw new Error(`Invalid version: ${version}`);
  }
}
